import { useNavigate } from 'react-router-dom'

import {
  Box,
  Button,
  List,
  type MediumIcon,
  Row,
  Title,
} from '@factorialco/deprecated-design-system'
import { SettingCyclesDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { checkFeatures } from 'modules/core/hooks/useFeatures'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

export interface ModuleConfig {
  key: string
  titleKey: string
  illustration: MediumIcon
  navigationPath: string
}

const Cycles = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, loading, error } = useQuery(SettingCyclesDocument, {
    variables: {
      featureIds: ['dev_bookkeepers_management_cycles'],
      companyId,
    },
  })
  const cycles = data?.compensations?.cyclesConnection?.nodes ?? []

  const { has_dev_bookkeepers_management_cycles } = checkFeatures(
    ['dev_bookkeepers_management_cycles'],
    data?.features?.featuresConnection?.nodes ?? []
  )

  if (loading) {
    return <Loading />
  }

  if (error) {
    throw new Error('Error fetching data')
  }

  return (
    <Box flexDirection="row" alignItems="center" paddingX="s64" paddingY="s32" width="full">
      <Row>
        <Row.Col halfWidth>
          <Box paddingRight="s64">
            <Title
              variant="500"
              title={i18n.t('compensations.settings.cycles.title')}
              description={i18n.t('compensations.settings.cycles.description')}
              illustration={'calendar-clock'}
            />
          </Box>
        </Row.Col>
        <Row.Col halfWidth>
          <List>
            {cycles.map((cycle) => {
              if (has_dev_bookkeepers_management_cycles) {
                return (
                  <List.Item key={cycle.country}>
                    <Box flexDirection="column">
                      <List.Title>{cycle.countryLabel}</List.Title>
                      <List.Description>{cycle.legalEntitiesLabel}</List.Description>
                    </Box>
                    <List.ActionItem>
                      <Button
                        type="secondary"
                        iconName="arrow-right"
                        onClick={() =>
                          navigate(
                            navigation.settings.compensations.cycles.id.fullPath({ id: cycle.id })
                          )
                        }
                      ></Button>
                    </List.ActionItem>
                  </List.Item>
                )
              } else {
                return (
                  <List.Item key={cycle.country}>
                    <List.Title>{cycle.countryLabel}</List.Title>
                    <List.Description>{cycle.legalEntitiesLabel}</List.Description>
                  </List.Item>
                )
              }
            })}
          </List>
        </Row.Col>
      </Row>
    </Box>
  )
}

export default Cycles
